import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CenterTreatmentReport from "../components/CenterTreatmentReport";
const TreatmentOverviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Centers Treatment Overview" />

        <CenterTreatmentReport />

      </MasterLayout>
    </>
  );
};

export default TreatmentOverviewPage;
